import { Component, Prop } from 'vue-property-decorator';
import { Block } from '@/helpers/components';
import { BaseBlock } from '@/blocks/base-block';
import { favoriteProductsData } from './favorite-products-list.data';
import { InstanceType } from '@/enums/InstanceType';
import { ApartmentMicroDTO } from '../../../model/ApartmentMicroDTO';

@Block(favoriteProductsData) @Component
export class FavoriteProductsListBlock extends BaseBlock {
	@Prop() favoriteProducts: ApartmentMicroDTO[];

	actualFavs: ApartmentMicroDTO[] = []

	numPlansLoaded: number = 0;

	mounted() {
		this.actualFavs = this.favoriteProducts;
		this.$root.$on("user-changed", (par: string) => this.reload())
	}

	async reload() {
		this.actualFavs = (await favoriteProductsData(this, this.block)).favoriteProducts;
	}

	get isEnoughPlansLoaded() {
		return this.numPlansLoaded >= 0	// TODO change to > 0; >= is only a temporary hack to workaround plans loading problems
	}

	customBoIdMapping(number: string) {
		return { [InstanceType.Apartment]: number }
	}

	removeFavorite(catalogNumber: string) {
		this.$cookiesService.setFavoriteProducts(this.$cookiesService.getFavoriteProducts().filter(p => p != catalogNumber));
		this.actualFavs = this.actualFavs.filter(p => this.$cookiesService.getFavoriteProducts().includes(p.catalogNumber))
	}

}

export default FavoriteProductsListBlock;
